module.exports = __webpack_public_path__ + "static/media/icon-grave.c68d66ad.svg";